import {styled} from "@mui/material";
import {Virtuoso} from "react-virtuoso";

export const VirtualizedList = styled(Virtuoso)({
    height: '100%',
    width: '100%',
    minHeight: 0,
    // Horizontal scrolling is owned by the outer wrapper in ResourcesList.
    // Prevent Virtuoso's internal scroller from creating a second X scrollbar.
    '& .virtuoso-scroller': {
        overflowX: 'hidden',
    },
})